import PricingButton from './PricingButton';

const PricingCard = ({ plan }) => {
  return (
    <div
      className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-105 ${
        plan.popular ? 'ring-4 ring-orange-500' : ''
      }`}
    >
      {/* Popular Badge */}
      {plan.popular && (
        <div className="absolute top-0 right-0 bg-gradient-to-r from-orange-600 to-orange-500 text-white px-4 py-1 text-sm font-semibold rounded-bl-lg">
          MOST POPULAR
        </div>
      )}

      {/* Card Content */}
      <div className="p-8">
        {/* Plan Name */}
        <h3 className="text-2xl font-bold text-gray-800 mb-2">
          {plan.name}
        </h3>

        {/* Price */}
        <div className="mb-6">
          <span className="text-5xl font-bold text-gray-900">
            {plan.price}
          </span>
          <span className="text-gray-600 ml-2">/ package</span>
        </div>

        {/* Key Features */}
        <div className="space-y-3 mb-6 pb-6 border-b border-gray-200">
          <div className="flex items-center">
            <span className="text-2xl mr-3">⏱️</span>
            <div>
              <p className="text-sm text-gray-500">Interview Time</p>
              <p className="font-semibold text-gray-800">{plan.features.interviewTime}</p>
            </div>
          </div>
          <div className="flex items-center">
            <span className="text-2xl mr-3">💬</span>
            <div>
              <p className="text-sm text-gray-500">Feedback Time</p>
              <p className="font-semibold text-gray-800">{plan.features.feedbackTime}</p>
            </div>
          </div>
        </div>

        {/* Extra Features */}
        <ul className="space-y-3 mb-8">
          {plan.features.extras.map((extra, idx) => (
            <li key={idx} className="flex items-start">
              <svg
                className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="text-gray-700">{extra}</span>
            </li>
          ))}
        </ul>

        <PricingButton plan={plan} />
      </div>
    </div>
  );
};

export default PricingCard;